function getCartAddToastSuccessMessage() {
  var settings = window.themeSettings || {};
  return settings.cart_add_toast_message_success;
}

function getCartAddToastErrorMessage() {
  var settings = window.themeSettings || {};
  return settings.cart_add_toast_message_error;
}

class Cart extends HTMLElement {
  constructor() {
    super();
    this.sectionId = this.dataset.sectionId;
  }

  cartUpdate(itemCount = null) {
    let pageCart;
    let url;

    if (this.sectionId) {
      pageCart = document.querySelector(`.minicart-drawer__inner`);
      url = `cart?section_id=${this.sectionId}`;
    } else {
      pageCart = document.querySelector('#page-cart');
      url = '/cart';
    }
    
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        let newPageCart;
        
        if (this.sectionId) {
          newPageCart = html.querySelector(`.minicart-drawer__inner`);
        } else {
          newPageCart = html.querySelector('#page-cart');
        }      
        
        if (pageCart && newPageCart) {
          pageCart.innerHTML = newPageCart.innerHTML;
          
          if (itemCount !== null && itemCount !== undefined) {
            updateCartCounters(itemCount);
          } else {
            updateCartCounters();
          }
          
          const cartUpdateEvent = new CustomEvent('cart:updated', {
            bubbles: true,
            detail: {
              sectionId: this.sectionId
            }
          });
          document.dispatchEvent(cartUpdateEvent);
        }
      })
      .catch((e) => {
        console.error('Erro ao atualizar carrinho:', e);
      });
  }
}

function isMainCartPageForTracking() {
  const path = window.location.pathname.replace(/\/+$/, '') || '/';
  return path === '/cart' || path.endsWith('/cart');
}

/**
 * @param {HTMLElement} hostEl cart-item-manager
 * @param {number} prevQty
 * @param {number} newQty
 * @returns {{ value: number; items: object[] } | null}
 */
function buildRemoveFromCartPayloadFromManager(hostEl, prevQty, newQty) {
  const prev = Number(prevQty);
  const next = Number(newQty);
  if (!Number.isFinite(prev) || !Number.isFinite(next) || prev <= next) return null;
  const removed = prev - next;
  const variantId = hostEl.dataset.lineVariantId || '';
  const productId = hostEl.dataset.lineProductId || '';
  const finalLineCents = parseInt(hostEl.dataset.lineFinalPrice || '0', 10) || 0;
  const titleEl = hostEl.querySelector('.cart-item__name');
  const itemName = titleEl && titleEl.textContent ? titleEl.textContent.trim() : '';
  const unitMajor = prev > 0 ? finalLineCents / prev / 100 : 0;
  const value = Math.round(unitMajor * removed * 100) / 100;
  return {
    value: value,
    items: [
      {
        item_id: String(variantId || productId || ''),
        item_name: itemName,
        quantity: removed,
        price: Math.round(unitMajor * 100) / 100,
      },
    ],
  };
}

function buildRemoveFromCartPayloadForFullClear() {
  const managers = document.querySelectorAll('#page-cart cart-item-manager');
  if (!managers.length) return null;
  const items = [];
  let totalValue = 0;
  for (let i = 0; i < managers.length; i++) {
    const hostEl = managers[i];
    if (!(hostEl instanceof HTMLElement)) continue;
    const prevQty =
      parseInt(hostEl.dataset.lineQty || hostEl.dataset.quantity || '0', 10) || 0;
    if (prevQty <= 0) continue;
    const part = buildRemoveFromCartPayloadFromManager(hostEl, prevQty, 0);
    if (part && part.items && part.items[0]) {
      items.push(part.items[0]);
      totalValue += part.value;
    }
  }
  if (!items.length) return null;
  return { value: Math.round(totalValue * 100) / 100, items: items };
}

class CartItemManager extends Cart {
  constructor() {
    super();
  }

  connectedCallback() {
    this.variantKey = this.dataset.variantKey;
    this.currentQuantity = parseInt(this.dataset.quantity);
    this.productPlus = this.querySelector('[data-action="increase"]');
    this.productMinus = this.querySelector('[data-action="decrease"]');
    this.btnRemove = this.querySelector('[data-action="remove"]');
    this.productQtda = this.querySelector('[data-quantity-input]');

    this.init();
  }

  init() {
    if (this.btnRemove) {
      this.btnRemove.addEventListener("click", this.removeProduct.bind(this));
    }
    if (this.productPlus) {
      this.productPlus.addEventListener("click", this.plusProductQtda.bind(this));
    }
    if (this.productMinus) {
      this.productMinus.addEventListener("click", this.minusProductQtda.bind(this));
    }
    if (this.productQtda) {
      this.productQtda.addEventListener("change", this.productChange.bind(this));
    }
  }

  /**
   * @param {string} variantKey
   * @param {number} qtda
   * @param {number} [quantityBefore] quantidade antes da alteração (obrigatório se currentQuantity já foi mutado)
   */
  cartChange(variantKey, qtda, quantityBefore) {
    
    this.setControlsDisabled(true);

    const previousQty =
      quantityBefore !== undefined && quantityBefore !== null
        ? Number(quantityBefore)
        : this.currentQuantity;
    const newQty = Number(qtda);

    let removePayload = null;
    if (
      isMainCartPageForTracking() &&
      typeof window.trackEvent === 'function' &&
      !this.sectionId
    ) {
      removePayload = buildRemoveFromCartPayloadFromManager(this, previousQty, newQty);
    }

    const brinde = window.MadesaBrinde;
    const request =
      brinde && typeof brinde.buildCartLineChangeFromDom === 'function'
        ? brinde.buildCartLineChangeFromDom(variantKey, newQty)
        : { mode: 'change', id: variantKey, quantity: newQty };

    const url = request.mode === 'update' ? '/cart/update.js' : '/cart/change.js';
    const body =
      request.mode === 'update'
        ? JSON.stringify({ updates: request.updates })
        : JSON.stringify({ id: request.id, quantity: request.quantity });

    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: body,
    })
      .then((response) => response.json())
      .then((data) => {
        if (brinde && typeof brinde.applyCartMutationResponse === 'function') {
          brinde.applyCartMutationResponse(data);
        }

        if (removePayload && typeof window.trackEvent === 'function') {
          if (data.currency) removePayload.currency = data.currency;
          window.trackEvent('remove_from_cart', removePayload);
        }
        
        updateCartCounters(data.item_count);
        
        this.cartUpdate(data.item_count);
      })
      .catch((error) => {
        console.error('Erro ao modificar carrinho:', error);
        this.setControlsDisabled(false);
      });
  }

  setControlsDisabled(disabled) {
    if (this.productPlus) {
      this.productPlus.disabled = disabled;
    }
    if (this.productMinus) {
      this.productMinus.disabled = disabled;
    }
    if (this.productQtda) {
      this.productQtda.disabled = disabled;
    }
  }

  removeProduct() {
    this.cartChange(this.variantKey, 0);
  }

  plusProductQtda() {
    const prev = this.currentQuantity;
    const newValue = prev + 1;
    this.currentQuantity = newValue;
    this.cartChange(this.variantKey, newValue, prev);
  }

  minusProductQtda() {
    if (this.currentQuantity > 1) {
      const prev = this.currentQuantity;
      const newValue = prev - 1;
      this.currentQuantity = newValue;
      this.cartChange(this.variantKey, newValue, prev);
    }
  }

  productChange(event) {
    const target = event.currentTarget;
    const newValue = parseInt(target.value) || 1;
    
    if (newValue < 1) {
      target.value = 1;
      return;
    }
    
    const prev = this.currentQuantity;
    this.currentQuantity = newValue;
    this.cartChange(this.variantKey, newValue, prev);
  }
}

class CartCrossSellItem extends Cart {
  constructor() {
    super();
  }

  connectedCallback() {
    this.variantId = this.dataset.variantId;
    this.btnAdd = this.querySelector('[data-action="add-to-cart"]');

    this.init();
  }

  init() {
    if (this.btnAdd) {
      if (this._boundAddToCart) {
        this.btnAdd.removeEventListener("click", this._boundAddToCart);
      }
      this._boundAddToCart = this.addToCart.bind(this);
      this.btnAdd.addEventListener("click", this._boundAddToCart);
    }
  }

  disconnectedCallback() {
    if (this.btnAdd && this._boundAddToCart) {
      this.btnAdd.removeEventListener("click", this._boundAddToCart);
    }
  }

  setAddLoading(isLoading) {
    if (!this.btnAdd) return;
    this.btnAdd.classList.toggle('is-loading', isLoading);
    this.btnAdd.setAttribute('aria-busy', isLoading ? 'true' : 'false');
  }

  addToCart(event) {
    event.preventDefault();
    event.stopPropagation();
    
    if (this.btnAdd.disabled) return;

    const brinde = window.MadesaBrinde;
    const isBrindeVariant = brinde?.isBrindeVariant?.(this.variantId);

    if (isBrindeVariant && brinde?.isAddLocked?.()) {
      brinde.showError('already_in_cart');
      return;
    }

    this.btnAdd.disabled = true;

    const runAdd = () => {
      this.setAddLoading(true);
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: this.variantId,
          quantity: 1,
          ...(isBrindeVariant ? { properties: { _brinde: 'true' } } : {}),
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.status && data.status >= 400) {
            throw new Error(data.description || 'Cart add failed');
          }

          if (isBrindeVariant) {
            brinde?.releaseBrindeAddSuccess?.(undefined, this.variantId);
          }

          document.dispatchEvent(
            new CustomEvent('toast:show', {
              detail: {
                message: getCartAddToastSuccessMessage(),
                type: 'success',
              },
            })
          );
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          this.setAddLoading(false);
        })
        .catch((error) => {
          console.error('Erro ao adicionar ao carrinho:', error);
          if (isBrindeVariant) {
            brinde?.releaseBrindeAddFailed?.();
          }
          document.dispatchEvent(
            new CustomEvent('toast:show', {
              detail: {
                message: getCartAddToastErrorMessage(),
                type: 'error',
              },
            })
          );
          this.setAddLoading(false);
          if (!brinde?.isAddLocked?.()) {
            this.btnAdd.disabled = false;
          }
        });
    };

    if (isBrindeVariant && brinde?.validateBrindeAdd) {
      if (!brinde.tryBeginBrindeAdd()) {
        brinde.showError('already_in_cart');
        return;
      }

      brinde
        .confirmBrindeAdd({ variantId: this.variantId })
        .then((result) => {
          if (!result.ok) {
            brinde.showError(result.reason || 'already_in_cart');
            if (!brinde.isAddLocked()) {
              this.btnAdd.disabled = false;
            }
            return;
          }
          runAdd();
        })
        .catch(() => {
          brinde?.releaseBrindeAddFailed?.();
          if (!brinde?.isAddLocked?.()) {
            this.btnAdd.disabled = false;
          }
        });
      return;
    }

    runAdd();
  }
}

class CartClearButton extends Cart {
  constructor() {
    super();
  }

  connectedCallback() {
    this.btnClear = this.querySelector('[data-action="clear-cart"]');
    this.modal = this.querySelector('[data-clear-cart-modal]');
    this.modalOverlay = this.querySelector('[data-modal-overlay]');
    this.confirmBtn = this.querySelector('[data-action="confirm-clear"]');
    this.cancelBtn = this.querySelector('[data-action="cancel-clear"]');
    this.init();
  }

  init() {
    if (this.btnClear) {
      const handler = this.modal ? this.showModal.bind(this) : this.clearCart.bind(this);
      this.btnClear.addEventListener('click', handler);
    }

    if (this.confirmBtn) {
      this.confirmBtn.addEventListener("click", this.clearCart.bind(this));
    }

    if (this.cancelBtn) {
      this.cancelBtn.addEventListener("click", this.hideModal.bind(this));
    }

    if (this.modalOverlay) {
      this.modalOverlay.addEventListener("click", this.hideModal.bind(this));
    }

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.modal && this.modal.classList.contains('is-active')) {
        this.hideModal();
      }
    });
  }

  showModal(event) {
    event.preventDefault();
    if (this.modal) {
      this.modal.classList.add('is-active');
      document.body.style.overflow = 'hidden';
    }
  }

  hideModal() {
    if (this.modal) {
      this.modal.classList.remove('is-active');
      document.body.style.overflow = '';
    }
  }

  clearCart(event) {
    event.preventDefault();

    if (this.confirmBtn) {
      this.confirmBtn.disabled = true;
    }

    if (this.modal) {
      this.hideModal();
    }

    let removeAllPayload = null;
    if (isMainCartPageForTracking() && typeof window.trackEvent === 'function') {
      removeAllPayload = buildRemoveFromCartPayloadForFullClear();
    }

    fetch('/cart/clear.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      }
    })
    .then(response => response.json())
    .then(data => {
      if (removeAllPayload && typeof window.trackEvent === 'function') {
        if (data.currency) removeAllPayload.currency = data.currency;
        window.trackEvent('remove_from_cart', removeAllPayload);
      }
      this.cartUpdate();
    })
    .catch(error => {
      console.error('Erro ao limpar carrinho:', error);
      if (this.confirmBtn) {
        this.confirmBtn.disabled = false;
      }
    });
  }
}

class CartButtonClose extends Cart {
  constructor() {
    super();

    this.init();
  }

  init() {
    this.addEventListener('click', (e) => {
      e.preventDefault();
      document.dispatchEvent(new CustomEvent('minicart:close'));
    });
  }
}

class MinicartToggle extends Cart {
  constructor() {
    super();
    this.addEventListener('click', this.toggle.bind(this));
    this.selfHidden = false;
  }

  toggle() {
    const cartShipping = document.querySelector('cart-shipping');

    if (cartShipping) {
      cartShipping.style.display = this.selfHidden ? 'block' : 'none';
    }

    const cartCoupon = document.querySelector('cart-coupon');

    if (cartCoupon) {
      cartCoupon.style.display = this.selfHidden ? 'block' : 'none';
    }

    if (!this.selfHidden) {
      this.classList.add('in-hidden');
    } else {
      this.classList.remove('in-hidden');
    }

    this.selfHidden = !this.selfHidden;
  }
}

if (!customElements.get('cart-item-manager')) {
  customElements.define('cart-item-manager', CartItemManager);
}

if (!customElements.get('cart-cross-sell-item')) {
  customElements.define('cart-cross-sell-item', CartCrossSellItem);
}

if (!customElements.get('cart-clear-button')) {
  customElements.define('cart-clear-button', CartClearButton);
}

if (!customElements.get('cart-button-close')) {
  customElements.define('cart-button-close', CartButtonClose);
}

if (!customElements.get('minicart-toggle')) {
  customElements.define('minicart-toggle', MinicartToggle);
}

function syncCartCountSession(itemCount) {
  const count = Math.max(0, Number(itemCount) || 0);
  try {
    sessionStorage.setItem(
      'cart-count',
      JSON.stringify({
        value: String(count),
        timestamp: Date.now(),
      })
    );
  } catch (e) {
  }
}

function updateCartCounters(itemCount = null) {
  if (itemCount === null) {
    return fetch('/cart.js')
      .then((response) => response.json())
      .then((cart) => {
        updateCartCountersDOM(cart.item_count);
        syncCartCountSession(cart.item_count);
        return cart.item_count;
      })
      .catch((error) => {
        console.error('Erro ao atualizar contadores:', error);
        return null;
      });
  }

  updateCartCountersDOM(itemCount);
  syncCartCountSession(itemCount);
  return Promise.resolve(itemCount);
}

function updateCartCountersDOM(itemCount) {
  const count = Math.max(0, Number(itemCount) || 0);
  const displayValue = count > 0 ? String(count) : '';

  document.querySelectorAll('#header-group [data-cart-count]').forEach((el) => {
    el.textContent = displayValue;
    el.style.display = count > 0 ? '' : 'none';
  });

  document.querySelectorAll(
    '.cart-count-bubble span, #cart-icon-bubble span, .header__icon--cart .cart-count-bubble'
  ).forEach((el) => {
    el.textContent = count > 0 ? (count < 100 ? String(count) : '') : '';
    const bubble = el.closest('.cart-count-bubble, .cart-bubble');
    if (bubble instanceof HTMLElement) {
      bubble.classList.toggle('visually-hidden', count === 0);
      bubble.classList.toggle('hidden', count === 0);
    }
  });

  const mobileCounter = document.querySelector('.madesa-mobile-cart-count');
  if (mobileCounter) {
    mobileCounter.textContent = displayValue;
    mobileCounter.style.display = count > 0 ? '' : 'none';
  } else if (count > 0) {
    const mobileBtn = document.querySelector('.madesa-mobile-cart-btn');
    if (mobileBtn) {
      const span = document.createElement('span');
      span.className = 'madesa-mobile-cart-count';
      span.textContent = displayValue;
      mobileBtn.appendChild(span);
    }
  }
}

document.addEventListener('cart:refresh', (event) => {
  const skipCookie =
    typeof window.madesaShouldSkipCookieDiscount === 'function' &&
    window.madesaShouldSkipCookieDiscount();
  const waitForCookie =
    !skipCookie &&
    typeof window.madesaHasPdpCouponIntent === 'function' &&
    window.madesaHasPdpCouponIntent();
  const applyDiscount = skipCookie
    ? Promise.resolve()
    : waitForCookie && typeof window.madesaApplyCookieDiscountWhenReady === 'function'
      ? window.madesaApplyCookieDiscountWhenReady({ maxWait: 1800, interval: 50 })
      : typeof window.madesaApplyCookieDiscount === 'function'
        ? window.madesaApplyCookieDiscount()
        : Promise.resolve();

  const shouldRevealCoupon =
    (event && event.detail && event.detail.revealCoupon === true) || waitForCookie;

  applyDiscount
    .finally(() => refreshCart())
    .then(() => {
      if (
        shouldRevealCoupon &&
        typeof window.madesaRevealCartCouponUI === 'function'
      ) {
        window.madesaRevealCartCouponUI();
      }
    });
});

document.addEventListener('cart:updated', () => {

  setTimeout(() => {
    const totalElement = document.querySelector('[data-installment-base-cents], [data-base-total-cents]');
    if (totalElement) {
      const totalCents = parseInt(
        totalElement.getAttribute('data-installment-base-cents') || totalElement.getAttribute('data-base-total-cents'),
        10
      );
      if (!isNaN(totalCents)) {
        window.updateInstallmentsDisplay(totalCents);
      }
    }
  }, 100);
});

function refreshCart(sectionId = null, options = {}) {
  const openMinicart = options.openMinicart !== false;
  const tasks = [];

  const minicartContainer = document.querySelector('.minicart-drawer__inner');
  if (minicartContainer) {
    const minicartSection = minicartContainer.closest('[data-section-id]');
    const sectionIdToUse = minicartSection ? minicartSection.dataset.sectionId : sectionId;

    if (sectionIdToUse) {
      tasks.push(
        fetch(`/cart?section_id=${sectionIdToUse}`)
          .then((response) => response.text())
          .then((html) => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const newContent = doc.querySelector('.minicart-drawer__inner');

            if (newContent) {
              minicartContainer.innerHTML = newContent.innerHTML;

              document.dispatchEvent(
                new CustomEvent('cart:updated', {
                  bubbles: true,
                  detail: { sectionId: sectionIdToUse },
                })
              );
            }
          })
          .catch((error) => console.error('Erro ao atualizar minicart:', error))
      );
    }
  }

  const pageCart = document.querySelector('#page-cart');
  if (pageCart) {
    tasks.push(
      fetch('/cart')
        .then((response) => response.text())
        .then((html) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const newContent = doc.querySelector('#page-cart');

          if (newContent) {
            pageCart.innerHTML = newContent.innerHTML;

            document.dispatchEvent(
              new CustomEvent('cart:updated', {
                bubbles: true,
                detail: { sectionId: null },
              })
            );
          }
        })
        .catch((error) => console.error('Erro ao atualizar página do carrinho:', error))
    );
  }

  const refreshPromise = (tasks.length ? Promise.all(tasks) : Promise.resolve())
    .then(() => updateCartCounters())
    .finally(() => {
      if (openMinicart && window.Minicart && typeof window.Minicart.open === 'function') {
        window.Minicart.open();
      }
    });

  return refreshPromise;
}

window.addEventListener('pageshow', (event) => {
  if (event.persisted) {
    updateCartCounters();
  }
});

window.refreshCart = refreshCart;
window.updateCartCounters = updateCartCounters;

window.calculateInstallments = function(totalCents) {
  if (window.MadesaInstallmentRules?.resolveInstallments) {
    return window.MadesaInstallmentRules.resolveInstallments(totalCents, {
      ruleMode: window.themeSettings?.installment_rule_mode,
      globalMinUnits: window.themeSettings?.installment_min_price || 100,
      maxInstallments: window.themeSettings?.installment_max_count || 12,
      allowedRaw: window.themeSettings?.installment_allowed_counts || '',
    });
  }

  const minInstallmentValue = (window.themeSettings?.installment_min_price || 100) * 100;
  const maxInstallments = window.themeSettings?.installment_max_count || 12;
  let maxPossibleInstallments = Math.floor(totalCents / minInstallmentValue);
  if (maxPossibleInstallments > maxInstallments) maxPossibleInstallments = maxInstallments;
  if (maxPossibleInstallments < 2) {
    return { count: 0, value: 0 };
  }
  const installmentValue = Math.round(totalCents / maxPossibleInstallments);
  return { count: maxPossibleInstallments, value: installmentValue };
};

window.updateInstallmentsDisplay = function(totalCents) {
  const installmentInfo = document.querySelectorAll('[data-installment-info]');
  
  installmentInfo.forEach(element => {
    let { count, value } = window.calculateInstallments(totalCents);

    if (!(count >= 2)) {
      count = 1;
      value = totalCents;
    }

    element.style.display = '';
    element.setAttribute('data-installment-count', count);
    element.setAttribute('data-installment-value', value);

    const countDisplay = element.querySelector('[data-installment-count-display]');
    const valueDisplay = element.querySelector('[data-installment-value-display]');

    if (countDisplay) {
      countDisplay.textContent = `${count}x`;
    }
    if (valueDisplay) {
      const formatted = window.madesaFormatMoney(value);
      valueDisplay.textContent = formatted;
    }
  });
};

function getCartAddToastDurationMs() {
  var ms = window.themeSettings && window.themeSettings.cart_add_toast_duration_ms;
  if (typeof ms === 'number' && ms > 0) {
    return ms;
  }
  return 3000;
}

document.addEventListener('toast:show', (event) => {
  const detail = event.detail || {};
  const { message, type = 'success', duration = getCartAddToastDurationMs() } = detail;
  showToast(message, type, duration);
});

function showToast(message, type = 'success', duration) {
  if (message == null || String(message).trim() === '') {
    return;
  }
  if (typeof duration !== 'number' || duration <= 0) {
    duration = getCartAddToastDurationMs();
  }

  let toastContainer = document.getElementById('toast-container');
  if (!toastContainer) {
    
    const style = document.createElement('style');
    style.textContent = `
      #toast-container {
        position: fixed;
        bottom: 20px;
        left: 20px;
        z-index: 9999;
        display: flex;
        flex-direction: column;
        gap: 10px;
        pointer-events: none;
      }
      
      .toast {
        padding: 12px 20px;
        border-radius: 4px;
        font-size: 14px;
        font-weight: 500;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
        pointer-events: auto;
        cursor: pointer;
        animation: slideInRight 0.3s ease-in-out;
      }
      
      .toast-success {
        background-color: #4CAF50;
        color: #ffffff;
      }
      
      .toast-error {
        background-color: #f44336;
        color: #ffffff;
      }
      
      .toast-info {
        background-color: #2196F3;
        color: #ffffff;
      }
      
      .toast-remove {
        animation: slideOutRight 0.3s ease-in-out forwards;
      }
      
      @keyframes slideInRight {
        from {
          transform: translateX(100%);
          opacity: 0;
        }
        to {
          transform: translateX(0);
          opacity: 1;
        }
      }
      
      @keyframes slideOutRight {
        from {
          transform: translateX(0);
          opacity: 1;
        }
        to {
          transform: translateX(100%);
          opacity: 0;
        }
      }
    `;
    document.head.appendChild(style);
    
    toastContainer = document.createElement('div');
    toastContainer.id = 'toast-container';
    document.body.appendChild(toastContainer);
  }

  const toast = document.createElement('div');
  toast.className = `toast toast-${type}`;
  toast.textContent = message;

  toastContainer.appendChild(toast);

  setTimeout(() => {
    toast.classList.add('toast-remove');
    setTimeout(() => {
      toast.remove();
    }, 300);
  }, duration);

  toast.addEventListener('click', () => {
    toast.classList.add('toast-remove');
    setTimeout(() => {
      toast.remove();
    }, 300);
  });
};